import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

export default class AdminPreRegDocumentAbility extends Ability {
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  // Feature-AVAILABILITY gate: the Split flag AND the `prereg_document_upload`
  // subscription entitlement (the backend enforces the same subscription on the
  // draft-document upload-link endpoint). NOT an authorization check despite the
  // `manage` name — it MUST be paired with `can('review visitor-document')` (as
  // `canShowAdminPreRegSection` does) for the role check. Mirrors `document-upload`,
  // the visitor-side prereg gate: same subscription feature, different Split flag.
  get canManage(): boolean {
    return (
      this.featureFlags.isEnabled('admin-pre-reg-document-management') &&
      Boolean(this.state.vrSubscription?.canAccessPreregDocumentUpload)
    );
  }
}
